module.exports = {
  "calendar": "Kalenteri",
  "day": "p\xE4iv\xE4",
  "dayPeriod": "vuorokaudenaika",
  "endDate": "P\xE4\xE4ttymisp\xE4iv\xE4",
  "era": "aikakausi",
  "hour": "tunti",
  "minute": "minuutti",
  "month": "kuukausi",
  "second": "sekunti",
  "selectedDateDescription": function selectedDateDescription(args) {
    return "Valittu p\xE4iv\xE4m\xE4\xE4r\xE4: ".concat(args.date);
  },
  "selectedRangeDescription": function selectedRangeDescription(args) {
    return "Valittu aikav\xE4li: ".concat(args.startDate, " \u2013 ").concat(args.endDate);
  },
  "selectedTimeDescription": function selectedTimeDescription(args) {
    return "Valittu aika: ".concat(args.time);
  },
  "startDate": "Alkamisp\xE4iv\xE4",
  "timeZoneName": "aikavy\xF6hyke",
  "weekday": "viikonp\xE4iv\xE4",
  "year": "vuosi"
};